import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { selectSearchResults } from '@redux/selectors/OfficeSelector';
import {
  lookupOffices,
  setOfficeLookup,
} from '@redux/modules/office';

import OfficeLookupTable from '@components/table/OfficeLookupTable';
import OfficeSearchForm from '@components/form/forms/OfficeSearchForm';
import Card from '@components/smartAdminUI/Card';
import Modal from '@components/smartAdminUI/Modal';

const OfficeLookupModal = ({
  id = 'officeLookupModal',
  onChange = input => input,
}) => {
  const dispatch = useDispatch();
  const searchResults = useSelector(selectSearchResults);

  const officeSelected = row => {
    onChange(row);
    dispatch(setOfficeLookup(row.UniqueID));
  };

  const onSubmitClicked = values => {
    dispatch(lookupOffices(values));
  };

  return (
    <Modal
      id={id}
      modalHeader="Office Lookup"
      position="center"
      size="lg"
    >
      {searchResults && (
        <Card id="officesLookupTable">
          <OfficeLookupTable
            displayData={searchResults}
            onOfficeSelect={officeSelected}
            isModal
          />
        </Card>
      )}
      <Card id="agentsLookupForm">
        <OfficeSearchForm
          onSubmitClicked={onSubmitClicked}
        />
      </Card>
    </Modal>
  );
};

OfficeLookupModal.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
};

export default OfficeLookupModal;
